import * as React from 'react'
import { SVGProps } from 'react'

const SvgAlertIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
		<path d="M13 14h-2V9h2m0 9h-2v-2h2M1 21h22L12 2 1 21Z" />
	</svg>
)
export default SvgAlertIcon
